<ion-header
  class="ion-no-border"
  [ngClass]="
    platformType === PlatformEnum.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button id="back-modal-btn" data-cy="back-modal-btn" text="">
      </ion-back-button>
    </ion-buttons>
    <ion-label>
      {{ 'i18n.common.sortBy' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platformType === PlatformEnum.mobile
      ? 'scroll-y'
      : 'ion-content-no-overflow'
  "
>
  <div>
    <ion-list>
      <ion-item
        *ngFor="let sortOption of sortOptions; let i = index"
        [ngClass]="
          sortOption.sortName === sortSelection.fieldName
            ? 'sort-option-item-selected'
            : ''
        "
        [attr.data-cy]="'sort-option-' + i"
        (click)="sort(sortOption.sortName)"
      >
        <ion-label>
          {{ sortOption.label }}
        </ion-label>
        <ion-icon
          *ngIf="sortOption.sortName !== sortSelection.fieldName"
          [src]="'../../../../../../assets/icon/sort-by.svg'"
        ></ion-icon>

        <p
          *ngIf="
            isAsc(sortSelection.sortValue) &&
            sortOption.sortName === sortSelection.fieldName
          "
        >
          {{ 'i18n.common.sortAscending' | translate }}
        </p>
        <ion-icon
          *ngIf="
            isAsc(sortSelection.sortValue) &&
            sortOption.sortName === sortSelection.fieldName
          "
          [src]="'../../../../../../assets/icon/sort-asc.svg'"
          slot="end"
        ></ion-icon>

        <p
          *ngIf="
            !isAsc(sortSelection.sortValue) &&
            sortOption.sortName === sortSelection.fieldName
          "
        >
          {{ 'i18n.common.sortDescending' | translate }}
        </p>
        <ion-icon
          *ngIf="
            !isAsc(sortSelection.sortValue) &&
            sortOption.sortName === sortSelection.fieldName
          "
          [src]="'../../../../../../assets/icon/sort-desc.svg'"
          slot="end"
        ></ion-icon>
      </ion-item>
    </ion-list>
  </div>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="reset-modal-btn"
        data-cy="reset-modal-btn"
        [ngClass]="
          platformType !== PlatformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="resetSort()"
        translate
      >
        {{ 'i18n.common.reset' }}
      </ion-button>
      <ion-button
        id="save-modal-btn"
        data-cy="save-modal-btn"
        [ngClass]="
          platformType !== PlatformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="dismiss()"
        translate
      >
        {{ 'i18n.common.save' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
